module.exports = __webpack_public_path__ + "img/phone.332dbe2.svg";